<template>
	<div class="sortlist">
		<el-card>
			<el-tabs v-model="activetab" @tab-click="GetTabData">
			<el-tab-pane :label="tab.name" :name="tab.name" v-for="(tab,index) in tabs" :key="index">
				<span slot="label">{{ tab.name }}</span>
			<el-row>
				<el-col :span="17">
					<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
					<span style="color:transparent" v-if="tab.buttons.length < 1">占位</span>
				</el-col>
				<el-col :span="2" class="rightcol">
					<span>语言类型：</span>
				</el-col>
				<el-col :span="5" class="rightcol">
					<el-select size="small" v-model="lang" :clearable="true" style="200px" @change="getTablelist('0')">
						<el-option v-for="(item,index) in langlist" :key="index" :label="item.label" :value="item.value"></el-option>
					  </el-select>
				</el-col>
			</el-row>
			<el-row style="height:10px;"></el-row>
			<el-row>
				<el-col :span="24">
					<el-table
						:data="tableData"
						style="width: 100%"
						:row-key="row => { return row.p_no+'★'+row.lang }"
						border
						lazy
						:height="height"
						:load="loadChild"
						:excess-rows="5"
						:stripe="stripe"
						:highlight-current-row="false"
						inverse-current-row
						header-align="center"
						use-virtual
						:row-height="48"
						:tree-props="{ children: 'children', hasChildren: 'haschild' }"
						:header-cell-style="{ background: '#f5f5f5', color: '#606266', textAlign: 'center', paddingTop: '8px', paddingBottom: '8px' }"
						:cell-style="{ padding: '0px', height: '40px' }"
					>
						<el-table-column prop="p_sort" label="分类名称"></el-table-column>
						<el-table-column prop="p_no" label="分类编号"></el-table-column>
						<el-table-column prop="langtype" label="语言类型"></el-table-column>
						<el-table-column label="是否启用" width="180">
							<template slot-scope="scope">
								<el-switch
									v-model="scope.row.isenabled"
									:active-value="true"
									:inactive-value="false"
									active-color="#13ce66"
									@change="val => ChangeEnabled(val, scope.row)"
								></el-switch>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="230">
							<template slot-scope="scope">
								<el-dropdown size="mini" @command="val => handleMenu(val, scope.row)">
									<el-button type="primary" size="mini">
										操作
										<i class="el-icon-arrow-down el-icon--right"></i>
									</el-button>
									<el-dropdown-menu slot="dropdown" style="width:70px;text-align:center;">
										<el-dropdown-item command="edit">修 改</el-dropdown-item>
										<el-dropdown-item command="del">删 除</el-dropdown-item>
										<el-dropdown-item command="bindbrand" v-if="scope.row.ischild">绑定品牌</el-dropdown-item>
										<el-dropdown-item command="bindspec" v-if="scope.row.ischild">绑定规格</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								<el-button style="margin-left:10px" type="warning" size="mini" @click="addsonsort(scope.row)">添加子分类</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
			<div>
				<el-row>
					<el-col :span="12">
						<span>共 {{ count }} 条数据</span>
					</el-col>
				</el-row>
			</div>
			</el-tab-pane>
			</el-tabs>
		</el-card>
		<addcargosort ref="addcargosort"></addcargosort>
		<sortbind ref="sortbind"></sortbind>
		<importwin ref="importwin"></importwin>
		<exportwin ref="exportwin"></exportwin>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import handlerbutton from '@/components/handlerbutton/handler.vue';
import addcargosort from '@/components/baseinfo/addcargosort.vue';
import sortbind from '@/components/baseinfo/sortbind.vue';
import importwin from '@/components/order/importwin.vue'; //万能导入
import exportwin from '@/components/order/exportwin.vue';//导出
export default {
	components: {
		handlerbutton,
		addcargosort,
		sortbind,
		importwin,
		exportwin
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			tabs: [],
			tableData: [],
			height: (window.innerHeight * 68) / 100,
			load: false,
			stripe: true,
			count: 0,
			divclass: 'sortlist',
			lang:'',
			langlist:[],
			activetab:'',
			activeName:'',
			activeTabIndex: 0 ,//激活的选项卡index
			cargotype:'',
			divclass:'sortlist',
			mode:'商品分类'
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/baseinfo/baselist.scss');
		this.getTabs();
	},
	methods: {
		getTabs() {
			var that = this;
			this.tabs=[];
			this.$apipost.get.GetTabs({ parentid: 297 }).then(res => {
				if (res.tabs != undefined) {
					if (res.tabs.length > 0) {
						that.tabs = res.tabs;
						that.activeTabIndex = 0;
						that.activeName = that.tabs[that.activeTabIndex].type;
						that.activetab = that.tabs[that.activeTabIndex].name;
						that.getTablelist('0');
						that.GetLanglist();
					} else {
						that.getTabs();
					}
				} else {
					that.getTabs();
				}
			});
		},
		GetTabData(tab){
			if (tab != undefined) {
				this.activeTabIndex = tab.index;
				this.activeName = this.tabs[this.activeTabIndex].type;
				this.activetab = this.tabs[this.activeTabIndex].name;
				if(this.activeTabIndex==1)
					this.cargotype='mobile';
				else
					this.cargotype='';
				this.getTablelist('0');
			}
		},
		GetLanglist(){
			//debugger
			var that = this;
			this.$apipost.get.dic({ type: '语言类型' }).then(res => {
				//console.log('list',res.list);
				if (res.list != undefined) {
					that.langlist=res.list;
				}
			});
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			//debugger
			if (e.event == 'add') {
				if (this.$refs.addcargosort != undefined) this.$refs.addcargosort.init({ title: '添加一级分类',cargotype:this.cargotype });
			}
			if(e.event=='import'){
				if (this.$refs.importwin != undefined) {
					this.$refs.importwin.init({
						mode:'商品分类导入',
						dialogtitle:e.l_name,
						isreload:true
					  }
					);
				}
			}
			if(e.event=='export'){
				var that=this;
				if (that.$refs.exportwin != undefined) {
					var handtype=13;
					if(this.cargotype=='mobile')
						handtype=14;
						
					that.$refs.exportwin.init({
						handtype: handtype,
						pageparam:that._data,
						batch:'商品分类'
					});
				}
			}
		},
		addsonsort(row){
			if (this.$refs.addcargosort != undefined) this.$refs.addcargosort.init({ title: '添加子分类',parentsort:row.parentsort,p_p_no:row.p_no,cargotype:this.cargotype,lang:row.lang});
		},
		refreshgrid(){
			this.getTablelist('0');
		},
		getTablelist(pid,lang, resolve) {
			if(lang==undefined)
				lang=this.lang;
			var that = this;
			var paraminfo={
				p_p_no: pid,
				lang:lang,
				isenabled:'',
				cargotype:this.cargotype,
				isshowpic:0
			}
			//debugger
			this.$apipost.get.GetCargoSortList({paraminfo:paraminfo}).then(res => {
				if (res.list != undefined) {
					if (pid == '') that.count = res.list.length;
					if (resolve == undefined) {
						that.tableData = res.list;
					}
					else resolve(res.list);
				}else{
					if(pid==''){
						that.count=0;
						if (resolve == undefined) {
							that.tableData = [];
						}
						else resolve([]);
					}
					else resolve([]);
				}
			});
		},
		reloadpage(){
			this.GetTabData({index:this.activeTabIndex});
		},
		//加载子分类
		loadChild(tree, treeNode, resolve) {
			this.getTablelist(tree.p_no,tree.lang,resolve);
		},
		//更改启用状态
		ChangeEnabled(val, row) {
			var that = this;
			this.$tool.loading('正在设置', this.divclass);
			this.$apipost.post.SetCargoSortenabled({ p_no: row.p_no,lang:row.lang, type: val,cargotype:this.cargotype }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '0') {
					row.isenabled = !val;
					this.$tool.message('设置失败', 0);
				} else {
					this.$tool.message('设置成功', 1);
					that.getTablelist('0');
				}
			});
		},
		//操作菜单
		handleMenu(cmd, row) {
			if (cmd == 'del') {
				this.handleDelete(row);
			}
			else if(cmd=='edit')
			{
				if (this.$refs.addcargosort != undefined) this.$refs.addcargosort.init({ title: '编辑分类',id:row.id,cargotype:this.cargotype});
			}
			else if(cmd=='bindbrand')
			{
				if(this.$refs.sortbind!=undefined)
					this.$refs.sortbind.init({title:'绑定品牌',p_sort:row.p_sort,type:'1',cargotype:this.cargotype,lang:row.lang});
			}
			else if(cmd=='bindspec')
			{
				if(this.$refs.sortbind!=undefined)
					this.$refs.sortbind.init({title:'绑定规格',p_sort:row.p_sort,type:'2',cargotype:this.cargotype});
			}
		},
		//删除分类
		handleDelete(row) {
			var that = this;
			var title = '';
			if (row.hasChild) title = '删除【' + row.p_sort + '】会同步删除其所有子分类，确认要删除吗？';
			else title = '确认要删除【' + row.p_sort + '】吗？';
			this.$confirm(title, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			})
				.then(() => {
					this.$tool.loading('正在删除', this.divclass);
					this.$apipost.post.DelCargoSort_SC({ p_no: row.p_no,lang:row.lang, cargotype:that.cargotype }).then(res => {
						this.$tool.loadingclose();
						if (res.state == '1') {
							if(row.p_p_no=='0')
								that.getTablelist('0');
							else
								that.reloadpage();
						} else {
							this.$tool.message(res.message, 0);
						}
					});
				})
				.catch(() => {});
		}
	}
};
</script>

<style></style>
